var _clipPath, _clipPath2, _clipPath3, _clipPath4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 0h-400v300h400z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 300h-400v179.996h400z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 300h-400v179.996h400z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 50c0-27.6133-22.383-50-50-50h-300c-27.6172 0-50 22.3867-50 50v380c0 27.613 22.3828 50 50 50h240l110-110z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.13333333 0 0 -.13333333 0 64)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.93l107.07-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 480h-240c-27.6172 0-50-22.387-50-50v-380c0-27.6133 22.3828-50 50-50h300c27.617 0 50 22.3867 50 50v320zm-4.141-10 104.141-104.141v-315.859c0-22.0547-17.937-40-40-40h-300c-22.0586 0-40 17.9453-40 40v380c0 22.055 17.9414 40 40 40z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.93l107.07-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#7bb2d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 480h-240c-27.6172 0-50-22.387-50-50v-380c0-27.6133 22.3828-50 50-50h300c27.617 0 50 22.3867 50 50v320zm-4.141-10 104.141-104.141v-315.859c0-22.0547-17.937-40-40-40h-300c-22.0586 0-40 17.9453-40 40v380c0 22.055 17.9414 40 40 40z",
    fill: "#679fb7"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m344.355 384.973 96.79-96.793v96.793z",
    fill: "#679fb7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440 370h-60c-27.617 0-50 22.387-50 50v60h110z",
    fill: "#bdd9e8"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m108.281 407.328v-14.765h4.832c2.082 0 3.86.746 5.344 2.242 1.477 1.492 2.219 3.265 2.219 5.316 0 2.344-.832 4.16-2.512 5.449-1.66 1.289-4.043 1.934-7.109 1.934zm-12.1677 10.371h19.7267c5.305 0 9.582-1.547 12.832-4.633 3.254-3.093 4.883-7.156 4.883-12.199 0-3.308-.801-6.453-2.403-9.422-1.601-2.976-4.004-5.195-7.226-6.66-3.223-1.465-5.977-2.226-8.262-2.285l-7.207-.176v-22.324h-12.3437z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.758 417.699h12.168v-57.699h-12.11l-26.386 37.355v-37.355h-12.434v57.699h12.297l26.465-37.09z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.57 405.176-8.261-7.735c-1.719 2.989-3.868 5.219-6.407 6.7-2.558 1.48-5.214 2.222-8.007 2.222-4.512 0-8.426-1.715-11.75-5.14-3.329-3.43-4.989-7.473-4.989-12.129 0-4.953 1.66-9.153 4.989-12.59 3.324-3.445 7.335-5.164 12.023-5.164 2.539 0 5 .64 7.352 1.93 2.355 1.293 4.257 3.707 5.695 7.253h-13.672v11.25h26.641v-7.472c0-3.836-1.329-7.961-3.965-12.367-2.637-4.414-6.106-7.637-10.41-9.668-4.305-2.039-8.653-3.055-13.047-3.055-7.969 0-14.699 2.883-20.176 8.656-5.481 5.77-8.223 12.906-8.223 21.403 0 8.054 2.825 14.941 8.465 20.652 5.637 5.715 12.434 8.57 20.363 8.57 10.137 0 17.93-4.441 23.379-13.316",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e0e0e0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m150 219.996h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210 219.996h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270 219.996h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 219.996h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390 219.996h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150 160h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210 160h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270 160h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 160h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390 160h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 190h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180 190h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 190h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300 190h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360 190h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150 100h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210 100h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270 100h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 100h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390 100h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 130h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180 130h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 130h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300 130h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360 130h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 70h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180 70h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 70h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300 70h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360 70h-30v30h30z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.ed3648a55f32a04ce471d469ee69dc8d.svg";
export { ForwardRef as ReactComponent };